// extracted by mini-css-extract-plugin
export var label = "_aq-1";
export var reminder = "_aq-0";